// extracted by mini-css-extract-plugin
export default {"container":"integrations_container__jXCsh","card_wrapper":"integrations_card_wrapper__kHr+C"};